import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export enum InboxNotificationType {
    MESSAGE_SENT = "message_sent",
    RENTAL_REQUESTED = "rental_requested",
    RENTAL_RETURNED = "rental_returned",
    RENTAL_APPROVED = "rental_approved",
    NEW_MESSAGE = "new_message"
}

export interface WebsocketInboxReceiveModel {
    notification: InboxNotificationModel,
    activeChatChannelId: number | undefined
}

export interface InboxNotificationModel {
    notificationId: number,
    chatChannelId: number,
    type: InboxNotificationType,
    productName: string,
    createdDate: Date,
    senderProfilePicUrl: string,
    senderName: string,
    seen: boolean
}

export interface InboxNewNotificationModel {
    chatChannelId: number;
    notificationId: number;
}

export interface InboxNotificationState {
    incomingNotification?: InboxNotificationModel,
    unSeenNotifictions: number,
    newNotifications: InboxNewNotificationModel[],
    currentlyActiveChatId: number | undefined
}

const initialState: InboxNotificationState = {
    incomingNotification: undefined,
    unSeenNotifictions: 0,
    newNotifications: [],
    currentlyActiveChatId: undefined
}


export const inboxNotificationsSlice = createSlice({
    name: 'inbox',
    initialState,
    reducers: {
        setUnseenNotificationsCount: (state, action: PayloadAction<number>) => {
            state.unSeenNotifictions = action.payload;
        },
        addIncomingInboxNotification: (state, action: PayloadAction<InboxNotificationModel>) => {
            if (!action.payload.seen) {
                state.incomingNotification = action.payload;
                state.unSeenNotifictions = state.unSeenNotifictions + 1;
                state.newNotifications = [...state.newNotifications,
                    {chatChannelId: action.payload.chatChannelId, notificationId: action.payload.notificationId}]
            }
        },
        setNewNotificationsAsReadForChatChannel: (state, action: PayloadAction<number>) => {
            state.newNotifications = state.newNotifications.filter((itm) =>
                itm.chatChannelId != action.payload);
        },
        removeIncomingInboxNotification: (state) => {
            state.incomingNotification = undefined
        },
        updateCurrentlyActiveChatChannelId: (state, action: PayloadAction<number | undefined>) => {

        }
    }
})

export const {addIncomingInboxNotification, removeIncomingInboxNotification, setNewNotificationsAsReadForChatChannel,
    setUnseenNotificationsCount} =
    inboxNotificationsSlice.actions;

export default inboxNotificationsSlice.reducer;